import ReservationPayment from './ReservationPayment'

export default ReservationPayment
